import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=7859deec"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7859deec')) {
      api.createRecord('7859deec', component.options)
    } else {
      api.reload('7859deec', component.options)
    }
    module.hot.accept("./Survey.vue?vue&type=template&id=7859deec", function () {
      api.rerender('7859deec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey.vue"
export default component.exports